import * as actions from "./task.actions";

import _ from "underscore";

let initialState = {
  fetching: false,
  fetched: false,
  error: null,
  table: {
    currentFilter: null,
    pagination: { page: 1, take: 10 },
  },
  data: [],
  others: {
    fetched: false,
    fetching: false,
    data: {},
  },
  init: false,
};

const applications_tasks = (state = initialState, action) => {
  switch (action.type) {
    case actions.INIT_APPLICATION_TASKS_GET_SUCCESS:
      return Object.assign({}, state, {
        init: true,
      });

    case actions.APPLICATION_TASKS_GET_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
      });

    case actions.APPLICATION_TASKS_GET_SUCCESS:
      var apps = action.applications.applications.data.filter((app) => {
        return action.response.indexOf(app.Id) >= 0;
      });

      return Object.assign({}, state, {
        data: apps,
        fetched: true,
      });

    case actions.APPLICATION_TASKS_ASSING_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
      });

    case actions.APPLICATION_TASKS_ASSING_SUCCESS:
      var apps1 = action.applications.applications.data.filter((app) => {
        return action.response.indexOf(app.Id) >= 0;
      });

      return Object.assign({}, state, {
        data: apps1,
        fetched: true,
      });

    case actions.DROP_APPLICATION_TASK_GET_SUCCESS:
      var newData = state.data.slice();
      var idOfRemoved = action.dataSent;
      var indexOfRemoved = _.findIndex(newData, (item) => {
        return item.Id == idOfRemoved;
      });

      newData.splice(indexOfRemoved, 1);

      return Object.assign({}, state, {
        data: newData,
      });

    case actions.APPLICATION_TASKS_GET_OTHERS_REQUEST:
      return Object.assign({}, state, {
        others: Object.assign({}, state.others, {
          fetching: true,
        }),
      });

    case actions.APPLICATION_TASKS_GET_OTHERS_SUCCESS:
      return Object.assign({}, state, {
        others: Object.assign({}, state.others, {
          fetched: true,
          fetching: false,
          data: action.response,
        }),
      });

    case actions.APPLICATION_TASKS_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          pagination: Object.assign({}, state.table.pagination, {
            page: action.page,
          }),
        }),
      });

    case actions.APPLICATION_TASKS_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          currentFilter: Object.assign({}, state.table.currentFilter, {
            ...action.filter,
          }),
        }),
      });
    default:
      return state;
  }
};

export default applications_tasks;
